import kernelAPI from '@/services/axios/api.kernel';
import { AxiosResponse } from 'axios';
import { ref } from 'vue';
import {
  ConfiguracaoSegurancaModel,
  TokenTtlItemModel,
  UploadRestricaoModel,
} from '@/models/ferramentas/saeweb/configuracaoSeguranca.model';

/**
 * Incrementado a cada salvamento bem-sucedido de ConfiguracaoSeguranca. A configuração é buscada
 * só uma vez, no boot da SPA (App.vue) — sem isto, quem já está logado e salva um novo timeout de
 * inatividade continuaria com os timers antigos em memória até relogar/recarregar a página.
 */
export const versaoConfiguracaoSeguranca = ref(0);

class ConfiguracaoSegurancaService {
  obterConfiguracao(codigoContrato: number): Promise<AxiosResponse<ConfiguracaoSegurancaModel>> {
    return kernelAPI.get<ConfiguracaoSegurancaModel>(`/ConfiguracaoSeguranca/${codigoContrato}`);
  }

  async salvarConfiguracao(model: ConfiguracaoSegurancaModel): Promise<AxiosResponse<void>> {
    const response = await kernelAPI.put('/ConfiguracaoSeguranca', model);
    versaoConfiguracaoSeguranca.value += 1;
    return response;
  }

  obterTokenTtl(codigoContrato: number): Promise<AxiosResponse<TokenTtlItemModel[]>> {
    return kernelAPI.get<TokenTtlItemModel[]>(`/ConfiguracaoSeguranca/${codigoContrato}/TokenTtl`);
  }

  salvarTokenTtl(codigoContrato: number, itens: TokenTtlItemModel[]): Promise<AxiosResponse<void>> {
    return kernelAPI.put(`/ConfiguracaoSeguranca/${codigoContrato}/TokenTtl`, itens);
  }

  obterUploadRestricoes(codigoContrato: number): Promise<AxiosResponse<UploadRestricaoModel[]>> {
    return kernelAPI.get<UploadRestricaoModel[]>(`/ConfiguracaoSeguranca/${codigoContrato}/UploadRestricoes`);
  }

  salvarUploadRestricoes(codigoContrato: number, itens: UploadRestricaoModel[]): Promise<AxiosResponse<void>> {
    return kernelAPI.put(`/ConfiguracaoSeguranca/${codigoContrato}/UploadRestricoes`, itens);
  }
}

export default new ConfiguracaoSegurancaService();
